import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20cinematic%20home%20theater%20setup%20with%20large%20screen%20displaying%20colorful%20abstract%20shapes%2C%20warm%20ambient%20lighting%2C%20cozy%20dark%20room%20atmosphere%2C%20movie%20night%20vibe%2C%20entertainment%20technology%2C%20clean%20minimal%20aesthetic%2C%20soft%20glow%20from%20screen%2C%20comfortable%20viewing%20environment&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="91免费视频 - 在线观看高清视频"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            海量高清视频
            <span className="block text-primary-400">免费在线观看</span>
          </h1>
          <p className="text-base md:text-lg text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
            涵盖娱乐、教育、科技、生活等多种类型，无需注册，随时随地免费观看
          </p>

          {/* Search Bar */}
          <div className="max-w-md mx-auto mb-8">
            <div className="relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/50 text-lg"></i>
              <input
                type="text"
                placeholder="搜索你感兴趣的视频..."
                className="w-full pl-11 pr-5 py-3.5 text-sm rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white placeholder:text-white/40 focus:outline-none focus:border-primary-400 focus:bg-white/20 transition-all"
              />
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/entertainment"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              开始观看
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white text-sm font-medium rounded-full border border-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line text-lg"></i>
              了解更多
            </Link>
          </div>

          {/* Stats */}
          <div className="flex items-center justify-center gap-8 md:gap-12 mt-10">
            {[
              { value: '10,000+', label: '高清视频' },
              { value: '500万+', label: '活跃用户' },
              { value: '10+', label: '内容分类' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}